import { useTheme } from '@emotion/react';
import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Alert, Button, Icon, Modal, Text } from '~/components/blocks';
import {
  DirectVisitorDetailDialogProfileFragment,
  LineVisitorDetailDialogProfileFragment,
  PatientDetailDialogProfileFragment,
  WebVisitorDetailDialogProfileFragment,
} from '~/graphql/generated/graphql';
import { patientDetailDialogPatientCommentState } from '~/state/partials/patient_detail_dialog/atoms';

import { useDeletePatientComment } from './use-delete-patient-comment';

type Props = {
  patient?:
    | DirectVisitorDetailDialogProfileFragment
    | WebVisitorDetailDialogProfileFragment
    | PatientDetailDialogProfileFragment
    | LineVisitorDetailDialogProfileFragment;
};
export const DeleteFollowupCommentModal = (props: Props) => {
  const theme = useTheme();
  const { patient } = props;
  const [patientCommentState, setPatientCommentState] = useAtom(
    patientDetailDialogPatientCommentState,
  );
  const resetPatientCommentState = useResetAtom(patientDetailDialogPatientCommentState);
  const { deleteComment, error: deleteError } = useDeletePatientComment(patient?.__typename);

  const handleDeleteComment = useCallback(async () => {
    try {
      await deleteComment();
      setPatientCommentState((_state) => ({
        ..._state,
        selectedCommentId: null,
        isDeleteModalOpen: false,
      }));
    } catch {
      // 何もしない
    }
  }, [deleteComment, setPatientCommentState]);

  const handleClose = useCallback(() => resetPatientCommentState(), [resetPatientCommentState]);

  if (patient === undefined) return null;

  return (
    <Modal size="s" open={patientCommentState.isDeleteModalOpen} onClose={handleClose}>
      <Modal.Body>
        {deleteError && (
          <Alert status="error" whiteSpace="pre-wrap">
            {deleteError}
          </Alert>
        )}
        <Text size="l">
          {patient.familyName}
          {patient.givenName}様のフォローアップメモを削除
          <br />
          しますか？
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button use="secondary" onClick={handleDeleteComment}>
          <Icon icon="trash" size="s" color="white" />
          <Text marginLeft={theme.space.s} color="white">
            削除
          </Text>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
